<template>
  <div class="container">
    <div class="bg_img">
      <img src="@assets/images/projectBg.png" alt="" />
    </div>
    <form action="/">
      <div class="info_write">
        <span><img src="@assets/images/xiugaixinxi.png" class="img_info"/></span
        >信息填写
      </div>
      <div class="demand_unit">
        <span class="title_name">需求单位：</span>
        <input
          class="title_content"
          type="text"
          placeholder="请输入您所在公司名称"
          ref="company"
          @blur="unitOne"
        />
      </div>
      <div class="demand_unit">
        <span class="title_name">联系人：</span>
        <input
          class="title_content"
          type="text"
          placeholder="请输入联系人姓名"
          ref="name"
          @blur="unitTwo"
        />
      </div>
      <div class="demand_unit">
        <span class="title_name">联系方式：</span>
        <input
          class="title_content"
          type="text"
          placeholder="请输入联系人手机号"
          ref="phone"
          @blur="unitThree"
        />
      </div>
      <div class="demand_unit">
        <span class="title_name">定制用途：</span>
        <input
          class="title_content"
          type="text"
          placeholder="请输入您的用途"
          ref="use"
          @blur="unitFour"
        />
      </div>
      <div class="demand_unit">
        <span class="title_name">定制需求：</span>
        <input
          class="title_content"
          type="text"
          placeholder=""
          @blur="unitFive"
          ref="provide"
        />
      </div>
      <div class="yellow">（产品需求、时间需求等）</div>
      <div class="btn-info" @click="submit_all">
        <div class="btn">提交</div>
      </div>
    </form>
    <!-- <div class="footer">
      <div class="fo-top" slot-scope="scope">
        <span class="footer_video" @click="toqd(scope.row.id)">抢答器</span>
        <span class="footer_video" @click="totp(scope.row.id)">投票器</span>
        <span class="footer_video" @click="tobj(scope.row.id)">表决器</span>
      </div>
      <div class="fo-bottom" slot-scope="scope">
        <span class="footer_video" @click="towzh(scope.row.id)"
          >无纸化会议</span
        >
        <span class="footer_video" @click="topf(scope.row.id)">评分器</span>
      </div>
    </div> -->
    <!-- <div class="footer">
      <div class="fo-top">
        <span class="footer_video">抢答器</span>
        <span class="footer_video">投票器</span>
        <span class="footer_video">表决器</span>
      </div>
      <div class="fo-bottom">
        <span class="footer_video">无纸化会议</span>
        <span class="footer_video">评分器</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { projectCustom } from "@api/common";
import Vue from "vue";
import { Notify } from "vant";
Vue.use(Notify);
export default {
  data() {
    return {
      list: [],
      company: "company",
      name: "",
      phone: "",
      use: "",
      provide: "",
      firstName: "",
      lastName: "",
      email: ""
    };
  },
  created() {},
  methods: {
    onSubmit() {},
    // 获取整体数据
    getDataInfo() {
      projectCustom({
        company: this.company,
        name: this.name,
        phone: this.phone,
        use: this.use,
        provide: this.provide
      }).then(res => {
        console.log(res);
        if (res.status === 200) {
          Notify({
            type: "success",
            message: "已经提交成功，我们会尽快与您联系"
          });
        } else {
          return false;
        }
      });
    },
    // searchAndroid() {
    //   console.log("11111");
    // },
    unitOne() {
      if (this.$refs.company.value.trim() === "") {
        Notify({ type: "warning", message: "需求单位不能为空" });
        return false;
      } else {
        this.company = this.$refs.company.value;
      }
    },
    unitTwo() {
      if (this.$refs.name.value.trim() === "") {
        Notify({ type: "warning", message: "联系人不能为空" });
        return false;
      } else {
        this.name = this.$refs.name.value;
      }
    },
    unitThree() {
      if (this.$refs.phone.value.trim() === "") {
        Notify({ type: "warning", message: "联系单位不能为空" });
        return false;
      } else {
        this.phone = this.$refs.phone.value;
      }
      if (!/^1[3456789]\d{9}$/.test(this.$refs.phone.value.trim())) {
        Notify({ type: "warning", message: "您输入号码有误" });
        return false;
      }
    },
    unitFour() {
      if (this.$refs.use.value.trim() === "") {
        Notify({ type: "warning", message: "定制用途不能为空" });
        return false;
      } else {
        this.use = this.$refs.use.value;
      }
    },
    unitFive() {
      this.provide = this.$refs.provide.value;
      // console.log(this.$refs.provide.value);
    },
    submit_all() {
      if (this.$refs.company.value.trim() === "") {
        Notify({ type: "warning", message: "需求单位不能为空" });
        return false;
      } else if (this.$refs.name.value.trim() === "") {
        Notify({ type: "warning", message: "联系人不能为空" });
        return false;
      } else if (this.$refs.phone.value.trim() === "") {
        Notify({ type: "warning", message: "联系方式不能为空" });
        return false;
      } else if (this.$refs.use.value.trim() === "") {
        Notify({ type: "warning", message: "联系方式不能为空" });
        return false;
      } else {
        this.getDataInfo();
        console.log(this.company);
        console.log(this.name);
        console.log(this.phone);
        console.log(this.use);
        console.log(this.provide);
        this.$refs.company.value = "";
        this.$refs.name.value = "";
        this.$refs.phone.value = "";
        this.$refs.use.value = "";
        this.$refs.provide.value = "";
      }
    }
    // toqd(id) {
    //   console.log(id);
    // },
    // totp(id) {
    //   console.log(id);
    // },
    // tobj(id) {
    //   console.log(id);
    // },
    // towzh(id) {
    //   console.log(id);
    // },
    // topf(id) {
    //   console.log(id);
    // }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  position: relative;
  .bg_img {
    width: 100%;
    height: 30%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  form {
    padding: 0.1rem 0.25rem;
    position: absolute;
    top: 2.5rem;
    left: 5%;
    width: 90%;
    height: 9rem;
    background: #ffffff;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    margin: 0 auto;
    .info_write {
      font-family: SourceHanSansCN-Regular;
      font-size: 0.28rem;
      color: #3bbb61;
      text-align: left;
      padding-left: 15px;
      padding-top: 15px;
      span {
        width: 0.3rem;
        height: 0.3rem;
        margin-top: 5px;
        margin-right: 5px;
        .img_info {
          width: 0.25rem;
          height: 0.25rem;
        }
      }
    }
  }
  .demand_unit {
    padding-top: 0.34rem;
  }
  .title_name {
    padding-left: 15px;
    font-family: SourceHanSansCN-Regular;
    font-size: 0.25rem;
    width: 2rem;
    color: #999999;
    text-align: center;
    display: inline-block;
  }
  .title_content {
    display: inline-block;
    width: 60%;
    height: 0.7rem;
    line-height: 0.7rem;
    font-family: SourceHanSansCN-Regular;
    font-size: 0.25rem;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding-left: 10px;
  }
  .yellow {
    font-family: SourceHanSansCN-Regular;
    font-size: 0.27rem;
    color: #ffe000;
    text-align: right;
    margin-top: 0.27rem;
    margin-right: 0.4rem;
  }
  .btn-info {
    width: 100%;
    text-align: center;
    margin-top: 0.2rem;
    .btn {
      width: 2.7rem;
      height: 0.6rem;
      line-height: 0.6rem;
      background: #4c84ff;
      border-radius: 0.35rem;
      font-size: 0.25rem;
      color: #fff;
      position: absolute;
      bottom: 10%;
      left: 50%;
      transform: translate(-50%);
      font-family: SourceHanSansCN-Regular;
    }
  }
  .footer {
    display: none;
    margin-top: 8.1rem;
    text-align: center;
    .fo-bottom {
      margin-top: 0.1rem;
    }
    .footer_video {
      font-family: SourceHanSansCN-Regular;
      font-size: 0.21rem;
      color: #4c84ff;
      text-align: center;
      margin: 0 0.25rem;
    }
  }
}
</style>
